<script setup lang="ts">
import {ref} from "vue";
import {TestCate, TestSubCateSelector} from "@/types";
import {TestService} from "@/api/api.ts";
import {ElNotification} from "element-plus";
import {convertToTestSubCateSelector} from "@/utils/common.ts";

const oneCateList = ref<TestCate[]>()
const twoCateList = ref<TestSubCateSelector[]>()

const oneCateId = ref<number>()
const twoCateId = ref<number[]>()

let level = 0

const emit = defineEmits(["onFCateChange", "onCateChange"])

const getTestCateList = async () => {
  try {
    const res = await TestService.getOneClassifyList({})
    if (res.data.code === 200) {
      if (res.data.data) {
        oneCateList.value = [{id: 0, name: "全部", level: 1}, ...res.data.data]
      }
    } else {
      ElNotification.error({
        message: res.data.msg
      })
    }
  } catch (err) {
    console.warn(err)
  } finally {
  }
}

const getTestSubCate = async (level: number) => {
  try {
    const res = await TestService.getRestsClassifyList({
      cate_id: oneCateId.value,
      level: level
    })
    if (res.data.code === 200) {
      if (res.data.data) {
        const cateList = [{id: 0, name: "全部", list: []}, ...res.data.data]
        twoCateList.value =
            convertToTestSubCateSelector(cateList)
      }
    }
  } catch (err) {
    console.warn(err)
  }
}

const onOneCateChange = () => {
  const item = oneCateList.value?.filter(
      item => item.id == oneCateId.value
  )
  if (item && item.length > 0) {
    twoCateId.value = undefined
    twoCateList.value = []
    level = item[0].level
    getTestSubCate(level)
  }
  emit("onFCateChange")
}

const onCateChange = () => {
  if (twoCateId.value) {
    console.log(twoCateId.value[twoCateId.value.length - 1])
    emit("onCateChange", twoCateId.value[twoCateId.value.length - 1])
  }
}

const getFCateId = () => {
  return oneCateId.value
}

const getSCateId = () => {
  if (!twoCateId.value) {
    return undefined
  }
  return twoCateId.value[twoCateId.value.length - 1]
}

const reset = () => {
  twoCateList.value = []
  oneCateId.value = undefined
  twoCateId.value = undefined
}

getTestCateList()

defineExpose({
  getFCateId,
  getSCateId,
  reset
})
</script>

<template>
  <el-form-item label-position="right" label="一级分类">
    <el-select
        class="my-selector"
        v-model="oneCateId"
        placeholder="请选择一级分类"
        @change="onOneCateChange">
      <el-option
          v-for="item in oneCateList"
          :key="item.id" :label="item.name" :value="item.id">
      </el-option>
    </el-select>
  </el-form-item>
  <el-form-item label-position="right" label="二级分类">
    <el-cascader
        class="my-cascader"
        v-model="twoCateId"
        :options="twoCateList" :show-all-levels="false"
        @change="onCateChange"/>
  </el-form-item>
</template>

<style scoped>
</style>
